/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { getSubscriptions } from "../../../store/subscription-action";
import { formatDateToCustomString } from "../../../utils/utils";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import { useLocation, useNavigate } from "react-router-dom";
import { calculatePage } from "../../../utils/paging";
import SearchInput from "../../../components/Ui/Search";
import Pagination from "../../../components/Ui/Paging";
import Transaction from "./Transaction";

const ManagerSubscription = () => {
  const [subs, setData] = useState([]);
  const [selectedItem, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [paging, setPaging] = useState({
    page: parseInt(searchParams.get("page")) || 1,
    limit: parseInt(searchParams.get("limit")) || 10,
    sortBy: searchParams.get("sortBy") || "createdAt",
    sortType: searchParams.get("sortType") || "DESC",
    search: searchParams.get("search") || "",
    total: 0,
    totalPages: 0,
  });

  const setQueryParams = (queryParams) => {
    const searchParams = new URLSearchParams();

    Object.keys(queryParams).forEach((key) => {
      searchParams.set(key, queryParams[key]);
    });

    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dataSubs = await getSubscriptions(paging);
      setTimeout(() => {
        setData(dataSubs.data);
        setPaging((prev) => ({
          ...prev,
          total: dataSubs.total,
          totalPages: calculatePage(dataSubs.total, prev.limit),
        }));
        setLoading(false);
      });
    };
    fetchData();
    setTimeout(() => {
      setQueryParams(paging);
    });
  }, [
    paging.page,
    paging.limit,
    paging.sortBy,
    paging.sortType,
    paging.search,
  ]);

  const handlePageChange = (page) => {
    setPaging((prev) => ({
      ...prev,
      page,
    }));
  };

  const onSearch = (search) => {
    setPaging((prev) => ({
      ...prev,
      search,
    }));
  };

  // eslint-disable-next-line no-unused-vars
  const displayStatus = (item) => {
    if (item.status === "CANCELLED") {
      return (
        <span className="inline-flex items-center bg-green-100 text-slate-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
          {item.status}
        </span>
      );
    }

    if (new Date(item.nextBillingTime) > new Date()) {
      return (
        <span className="inline-flex items-center bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
          ACTIVE
        </span>
      );
    }

    return (
      <span className="inline-flex items-center bg-red-100 text-red-500 text-xs font-medium px-2.5 py-0.5 rounded-full">
        {item.status}
      </span>
    );
  };

  const dataSection = useMemo(() => {
    return (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3">
              ID
            </th>
            <th scope="col" className="px-6 py-3">
              Email
            </th>
            <th scope="col" className="px-6 py-3">
              Package
            </th>
            <th scope="col" className="px-6 py-3">
              Start
            </th>
            <th scope="col" className="px-6 py-3">
              Next Billing Time
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3">
              {/* <span>Action</span> */}
            </th>
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            subs?.map((item, index) => (
              <>
                <tr key={index} className="bg-white border-b">
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium  whitespace-nowrap"
                  >
                    {item.paypalSubscriptionId}
                  </th>
                  <td className="px-6 py-4">{item.user?.email}</td>

                  <td className="px-6 py-4 text-gray-900 font-semibold">
                    {item.plan?.name}
                  </td>
                  <td className="px-6 py-4">
                    {formatDateToCustomString(item.startTime)}
                  </td>
                  <td className="px-6 py-4">
                    {formatDateToCustomString(item.nextBillingTime)}
                  </td>
                  <td className="px-6 py-4 font-semibold">{item.status}</td>
                  <td>
                    <button
                      disabled={loading}
                      onClick={(e) => {
                        selectedItem && selectedItem._id === item._id
                          ? setItem(null)
                          : setItem(item);
                      }}
                      className="text-white disabled:bg-slate-200 disabled:cursor-not-allowed bg-slate-400 hover:bg-slate-600 rounded focus:ring-4 focus:ring-blue-300 font-medium text-sm px-2.5 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      {selectedItem && selectedItem._id === item._id
                        ? "Hide"
                        : "Refund"}
                    </button>
                  </td>
                </tr>
                {selectedItem && selectedItem._id === item._id && (
                  <tr>
                    <td></td>
                    <td colSpan={5}>
                      <Transaction subscription={selectedItem} />
                    </td>
                  </tr>
                )}
              </>
            ))
          ) : (
            <LoadingOverlay />
          )}
        </tbody>
      </table>
    );
  }, [subs, loading, selectedItem]);

  const pagine = useMemo(() => {
    if (!paging.totalPages || paging.total <= paging.limit) return <></>;
    return (
      <Pagination
        totalPages={paging.totalPages}
        currentPage={paging.page}
        onPageChange={handlePageChange}
      />
    );
  }, [paging.page, paging.totalPages]);

  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <div className="flex w-full justify-between items-center p-3 flex-wrap md:flex-nowrap">
        <h2 className="font-semibold text-3xl text-left rtl:text-right text-gray-900">
          Subscription
        </h2>
        <SearchInput className="md:mr-28" onSubmitSearch={onSearch} />
      </div>
      {dataSection}
      {pagine}
      {loading && <LoadingOverlay />}
    </div>
  );
};

export default ManagerSubscription;
